import axios from "axios";
import React, { useState, useEffect } from "react";
// const axios = require('axios');
const ExpenseModal = ({ isOpen, setModal, onClose, groupData }) => {
  const [expenseName, setExpenseName] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [payer, setPayer] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [splitUnequal, setSplitUnequal] = useState(false);
  const [people, setPeople] = useState([]);
  const [shareArray, setShareArray] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  // console.log(groupData)
  // Effect to fetch data when the component mounts

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make the API call
        const response = await axios.get(
          `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/members/${groupData.groupid}`,
          {
            headers: {
              Authorization: `Bearer ${user.idToken}`,
            },
          }
        );

        // Set the response data to state
        // console.log(response.data);
        setPeople(response.data);
      } catch (error) {
        // Handle errors
        console.error("Error fetching data:", error);
      }
    };

    // Call the fetch function
    fetchData();
  }, [isOpen]);

  const handleSaveExpense = async () => {
    if (IsAmountValid) {
    }
    let participants;
    if (shareArray.length > 0) {
      participants = shareArray.map((person) => ({
        UserId: person.person,
        Share: person.share,
      }));
    } else {
      participants = selectedPeople.map((person) => ({
        UserId: person,
        Share: parseFloat((amount / selectedPeople.length).toFixed(2)),
      }));
      const delta =
        amount -
        participants.reduce(
          (accumulator, currentValue) => accumulator + currentValue.Share,
          0
        );
      if (delta !== 0) {
        participants[0].Share += parseFloat(delta);
        participants[0].Share = parseFloat(participants[0].Share.toFixed(2));
      }
      console.log("delts",delta)
    }

    const expenseData = {
      TotalAmount: parseFloat(amount, 10),
      PaidBy: payer,
      GroupId: groupData.groupid,
      Participants: participants,
      Description: expenseName,
      IsSettle: false,
    };
    

    try {
      const res = await axios.post(
        "https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/expenses/create",
        expenseData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.idToken}`,
          },
        }
      );
      alert("Expense added successfully");
    } catch (error) {
      alert(error);
    }
    onClose();
  };

  const handleCheckboxChange = (person, isChecked) => {
    if (isChecked) {
      setSelectedPeople([...selectedPeople, person]);
    } else {
      setSelectedPeople(selectedPeople.filter((p) => p !== person));
    }
  };

  const handleShare = (person, share = 0) => {
    // Check if the person is already present in the array
    const index = shareArray.findIndex((obj) => obj.person === person);

    if (index !== -1) {
      // Person found, update the share value
      const updatedArray = [...shareArray];
      updatedArray[index].share = share;
      setShareArray(updatedArray);
    } else {
      // Person not found, add a new object to the array
      setShareArray((prevArray) => [...prevArray, { person, share }]);
    }
  };
  const handleToggleButton = () => {
    setSplitUnequal(!splitUnequal);
    setShareArray([]);
    setSelectedPeople([]);
  };
  const IsAmountValid = () => {
    if (shareArray.length > 0) {
      const sum = shareArray.reduce(
        (accumulator, currentValueObj) => accumulator + currentValueObj.share,
        0
      );
      if (sum != amount) return false;
    }
    return true;
  };
  const validateExpense = () => {
    if (expenseName && amount && selectedPeople.length > 0 && payer)
      return true;
    else return false;
  };

  return (
    <>
      {isOpen && (
        <div className="fixed w-full h-full top-0 left-0 z-10  inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="w-full inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full h-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                      Add Expense
                    </h3>

                    <div className="mb-4">
                      <label
                        for="expenseName"
                        className="block overflow-hidden rounded-md border border-gray-200 px-3 py-2 shadow-sm focus-within:border-green-600 focus-within:ring-1 focus-within:ring-green-600"
                      >
                        <span className="text-xs font-medium text-gray-700">
                          {" "}
                          Expense Name{" "}
                        </span>

                        <input
                          type="text"
                          id="expenseName"
                          placeholder="Travel"
                          className="mt-1 w-full border-none p-0 focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                          required
                          value={expenseName}
                          onChange={(e) => setExpenseName(e.target.value)}
                        />
                      </label>
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="amount"
                        className="block overflow-hidden rounded-md border border-gray-200 px-3 py-2 shadow-sm focus-within:border-green-600 focus-within:ring-1 focus-within:ring-green-600"
                      >
                        <span className="text-xs font-medium text-gray-700">
                          {" "}
                          Amount{" "}
                        </span>

                        <input
                          type="number"
                          id="amount"
                          className="mt-1 w-full border-none p-0 focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                          required
                          placeholder="0.00"
                          value={amount}
                          onChange={(e) =>
                            setAmount(parseFloat(e.target.value))
                          }
                        />
                      </label>
                    </div>

                    <div className="mb-4 ">
                    <label className="block text-sm font-medium  text-gray-700 mb-1">
                        People Involved
                      </label>
                      <div className="relative">
                        <button
                          type="button"
                          className="transition-all duration-3000 ease-in-out inline-flex items-center justify-center w-full border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100"
                          onClick={() => setIsExpanded(!isExpanded)}
                        >
                          Select People ({selectedPeople.length})
                          {/* Dropdown arrow icon */}
                          <svg
                            className="-mr-1 ml-2 h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 12a1 1 0 01-.7-.29l-4-4a1 1 0 011.42-1.42L10 9.58l3.29-3.29a1 1 0 111.42 1.42l-4 4a1 1 0 01-.71.29z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        {/* Dropdown content */}
                        {isExpanded ? (
                          <div className="relative top-full rounded-md z-10 overflow-hidden bg-white shadow-lg ">
                            <div className={`relative inline-block`}>
                              <input
                                type="checkbox"
                                id="toggleSwitch"
                                className="sr-only"
                                checked={splitUnequal}
                                onChange={handleToggleButton}
                              />
                              <label
                                htmlFor="toggleSwitch"
                                className={`flex items-center cursor-pointer`}
                              >
                        
                                <div
                                  className={`w-10 h-4 bg-gray-200 ${
                                    splitUnequal ? "bg-green-500" : "bg-gray-400"
                                  } rounded-full shadow-inner`}
                                ></div>
                                <div
                                  className={`w-6 h-6 bg-white rounded-full shadow-md absolute left-0 transition transform duration-200 ease-in-out ${
                                    splitUnequal ? "translate-x-full" : ""
                                  }`}
                                ></div>
                                <span className="text-xs p-2 font-medium text-gray-700">
                          {" "}
                               Split manually{" "}
                        </span>
                              </label>
                            </div>
                            <div className="py-1 max-h-[50vh] overflow-y-auto">
                              {people.map((person, i) => (
                                <div key={i} className="flex items-center ">
                                  <input
                                    type="checkbox"
                                    id={person.email}
                                    className="mr-2 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    onChange={(e) => {
                                      handleCheckboxChange(
                                        person.email,
                                        e.target.checked
                                      );
                                      if (splitUnequal)
                                        handleShare(person.email);
                                    }}
                                    checked={selectedPeople.includes(
                                      person.email
                                    )}
                                  />
                                  <label
                                    htmlFor={person.email}
                                    className="block overflow-hidden w-full rounded-md border border-gray-200 px-3 py-2 shadow-sm focus-within:border-green-600 focus-within:ring-1 focus-within:ring-green-600"
                                  >
                                    {person.name}
                                    {/* Text box after name */}
                                    {/* <div className="flex align-items-end"> */}
                                    {splitUnequal ? (
                                      <input
                                        type="text"
                                        className="mt-1 w-full border-none p-0 focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                        placeholder="Enter Amount"
                                        onChange={(e) =>
                                          handleShare(
                                            person.email,
                                            parseFloat(e.target.value)
                                          )
                                        }
                                        value={
                                          shareArray.find(
                                            (shareObj) =>
                                              shareObj.person === person.email
                                          )?.share || 0
                                        }
                                      />
                                    ) : null}
                                  </label>

                                  {/* </div> */}
                                </div>
                              ))}
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                              <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                                onClick={() => {
                                  IsAmountValid()
                                    ? setIsExpanded(!isExpanded)
                                    : alert("please enter valid amount");
                                }}
                              >
                                Done
                              </button>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="mb-4 my-5">
                      <label
                        htmlFor="payer"
                        className="block text-sm font-medium text-gray-900"
                      >
                        Who Paid
                      </label>
                      <select
                        id="payer"
                        className="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 sm:text-sm"
                        required
                        value={payer}
                        onChange={(e) => setPayer(e.target.value)}
                      >
                        <option value="">Select Payer</option>
                        {people.map((person, i) => (
                          <option key={i} value={person.email}>
                            {person.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 m-5 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() =>
                    validateExpense()
                      ? handleSaveExpense()
                      : alert("please select all the fields")
                  }
                >
                  Save
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => {
                    setModal(false);
                    setSelectedPeople([]);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpenseModal;
